import { render, staticRenderFns } from "./electronic-signature.component.vue?vue&type=template&id=21fc3b23"
import script from "./electronic-signature.component.vue?vue&type=script&lang=js"
export * from "./electronic-signature.component.vue?vue&type=script&lang=js"
import style0 from "./electronic-signature.component.vue?vue&type=style&index=0&id=21fc3b23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports